module.exports = __webpack_public_path__ + "static/img/feedback-good.c809e1eb.jpg";